import { useState, useEffect } from "react";
import { BASE_URL, PAPIKEY } from "../api-contants";
import { currentCompetition } from "../util/filters";

export function useFetchCompetition(url, currentOperator) {
  const [competition, setCompetition] = useState(null);
  const [loading,setLoading] = useState(true)
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!currentOperator) return;
    const fetchData = async () => {
      try {
        const res = await fetch(
          `${BASE_URL}${url}?operatorId=${currentOperator}`,
          {
            method: "GET",
            headers: {
              "X-PAPIKEY": `${currentOperator}${PAPIKEY}`,
              "Content-Type": "application/json; charset=utf-8"
            }
          }
        );
        if (!res.ok) {
          throw await res.json();
        }

        const data = await res.json();
        const curComp = currentCompetition(data);
        setCompetition(curComp);
        setLoading(false)
      } catch (error) {
        setError(error);
        setLoading(false);
      }
    };
    fetchData();
  }, [url, currentOperator]);
  return { competition,loading, error };
}

export function useFetchLeaderboard(url, currentOperator) {
  const [response, setResponse] = useState([]);
  const [error, setError] = useState(null);

  const fetchData = async (url,operatorId) => {
    if (!url) return
    try {
      const res = await fetch(
        `${BASE_URL}${url}?operatorId=${operatorId}`,
        {
          method: "GET",
          headers: {
            "X-PAPIKEY": `${operatorId}${PAPIKEY}`,
            "Content-Type": "application/json; charset=utf-8"
          }
        }
      );
      if (!res.ok) {
        throw await res.json();
      }

      const response = await res.json();

      setResponse(response || []);
    } catch (error) {
      setError(error);
    }
  }

  return [ response, error,fetchData ];
}

